import { CommunicationTemplatesTable } from "modules/CommunicationTemplates/components";

export const CommunicationTemplates = () => <CommunicationTemplatesTable />;
